import React, { Component } from "react"
import { Link, graphql } from "gatsby"

import SEO from "../components/seo"
import Logo from '../assets/images/long.png'

class IndexPage extends Component {

  render() {
    
    const { page } = this.props.data

    return (
      <>
        <SEO title={page.seo.title} bodyClass='home' description={page.seo.metaDesc} />
		    <section className='intro'>
		      <div className='intro__content'>
		        <img src={page.Home.home.image.sourceUrl} alt='Emily Gillis' />
		      </div>
		    </section>
      </>
    )
  }

}

export default IndexPage

export const indexQuery = graphql`
  query {
    page: wpPage(slug: { eq: "home" }){
      title
      seo {
        title
        metaDesc
      }
      Home {
        home {
          image {
            sourceUrl
          }
        }
      }
    }
  }
`
